import { createContext } from '@chakra-ui/react-context'

import type { CompanyCheckboxGroupContext } from './checkbox-types'

export const [CompanyCheckboxGroupProvider, useCompanyCheckboxGroupContext] =
  createContext<CompanyCheckboxGroupContext>({
    name: 'CompanyCheckboxGroupContext',
    strict: false,
  })
